/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from '@welldev-group/react-comp-lib';
import PropTypes from 'prop-types';

const LanguageSettings = props => {
  const { availableLocales, saveLocale } = props;

  return (
    <div>
      <ul className="navbar__language-settings">
        {availableLocales.map(availableLocale => (
          <li key={availableLocale.code} className="navbar__sub-menu-item">
            <Link onClick={() => saveLocale(availableLocale.code)}>
              <span className="navbar__sub-menu--language-name">{availableLocale.humanName}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

LanguageSettings.propTypes = {
  availableLocales: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      humanName: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  saveLocale: PropTypes.func.isRequired,
};

export default LanguageSettings;
